import { TicketData } from 'src/models/TicketStatus';

export const formatDataTicket = (data: TicketData) => {
    const newData = {
        ticket_id: data.ticket_id,
        ticket_type: data.ticket_type,
        register_id: data.register_id,
        user_id: data.user_id,
        fullname: data.fullname,
        phone_contact: data.phone_contact,
        phone_whatsapp: data.phone_whatsapp,
        email: data.email,
        notify_flag: data.notify_flag,
        exposure: data.exposure,
        note_content: data.note_content,
        note_updated_at: data.note_updated_at,
        note_updated_by: data.note_updated_by,
        note_updated_by_fullname: data.note_updated_by_fullname,
        attention_id: data.attention_id,
        typification_id: data.typification_id,
        assigned_user_id: data.assigned_user_id,
        recommendation_id: data.recommendation_id,
        user_size: data.user_size,
        campaign: data.campaign,
    };

    const result = {};

    for (const key in data) {
        const isValid = !!newData[key];
        // Verificar si el campo tiene valores
        if (newData.hasOwnProperty(key) && isValid) {
            result[key] = data[key];
        }
    }

    return result;
};
